import React from 'react'
import { View, ViewStyle, TextStyle, Platform } from 'react-native'
import { Text } from '../text'
import { spacing } from '../../theme'
import { SectionHeader } from '../section-header'

interface QuizDataProps {
  endDate: string | null
  maxAttempts: number
  questionCount: number
  completedAttempts: number
}

export const QuizData = (props: QuizDataProps) => {
  const { questionCount } = props

  return (
    <View>
      <SectionHeader headerTx="Quiz.about" />
      <View style={ABOUT}>
        <Text style={METADATA} tx="Quiz.numQuestions" txOptions={{ count: questionCount }} />
      </View>
    </View>
  )
}

const METADATA: TextStyle = {
  color: 'rgba(0,0,0,.5)',
  fontWeight: '500',
  fontSize: 16,
  lineHeight: 20,
  paddingBottom: 15,
}
const ABOUT: ViewStyle = {
  justifyContent: 'space-evenly',
  flexDirection: 'column',
  paddingHorizontal: Platform.OS === 'android' ? spacing[4] : 0,
}
